import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Check: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconEmail2Check"><Path d="M22 4V8.46191L12 13.501L3.5 9.21777V18.5H12V20H2V4H22Z" fill="currentColor"/><Path d="M23.5947 13.457L18.1191 20.5752L14.5195 17.5762L15.4805 16.4238L17.8809 18.4238L22.4053 12.543L23.5947 13.457Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2Check;
